export function asMetric(...types) {
    return types.join('.');
}
